import React, { FC } from 'react'
import { ActionIcon, Box, Menu, useMantineTheme } from '@mantine/core'
import { useClickOutside, useDisclosure, useWindowEvent } from '@mantine/hooks'
import { IconDots } from '@tabler/icons-react'
import { getBackgroundColor, getTextColor } from 'config/themeOverride/getColor'
import { Campaign } from 'types/domain'
import ActionMenus from 'components/business/Campaign/ActionMenus'

type Props = {
  campaign: Campaign
  onRefresh?: () => void
  onItemChange?: (campaign: Campaign) => void
}

const Actions: FC<Props> = (props) => {
  const theme = useMantineTheme()
  const { campaign, onRefresh, onItemChange } = props
  const [opened, { close, open }] = useDisclosure(false)
  const ref = useClickOutside(() => close())

  useWindowEvent('resize', close)

  const handleClickEventPropagation = (event: any) => {
    close()
    event.stopPropagation()
  }

  const handleDotsClick = (event: any) => {
    handleClickEventPropagation(event)
    open()
  }

  return (
    <Menu
      width={160}
      withinPortal
      shadow="xl"
      offset={4}
      closeOnItemClick
      position="bottom-end"
      opened={opened}
      styles={(theme) => ({
        itemIcon: {
          color: getTextColor('gray.7', theme),
        },
      })}
    >
      <Menu.Target>
        <ActionIcon
          color="dimmed"
          onClick={handleDotsClick}
          sx={(theme) => ({
            '&:hover': {
              backgroundColor: getBackgroundColor('gray.1', theme),
            },
          })}
        >
          <IconDots size={18} stroke={2} color={getTextColor('gray.6', theme)} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown onClick={handleClickEventPropagation}>
        <Box ref={ref}>
          <ActionMenus campaign={campaign} onRefresh={onRefresh} onDelete={onRefresh} onChange={onItemChange} />
        </Box>
      </Menu.Dropdown>
    </Menu>
  )
}

export default Actions
